import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandHandclapIcon} from "@pg-design/icons-module";
import {type IModalOverlayVariant, Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {rpAppLink} from "@pg-mono/rp-routes";
import {PREFERENCES_SURVEY_MODAL_TEST_IDS} from "@pg-mono/test-ids/src/rp/common/test_id";
import {useUserDevice} from "@pg-mono/user-device";

import {useKMLink} from "../../../hooks/use_km_link";
import {useGetRegionDetailListQuery} from "../../../region/api/get_region_detail_list";
import {SearchTab} from "../../../search/types/SearchTab";
import {getSearchUrlWithFilters} from "../../../search/utils/get_search_url_with_filters";
import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../api/get_user_profile";
import {usePreferencesValues} from "../../hooks/preferences/use_preferences_values";

interface IProps {
    isOpen: boolean;
    onClose?: () => void;
    overlayVariant?: IModalOverlayVariant;
}

export const UserPreferencesUpdateDataModal = (props: IProps) => {
    const {isOpen, onClose, overlayVariant} = props;

    const {isMobile} = useUserDevice();

    const kmLink = useKMLink(kmAppLink.site.offers.myInquiriesWithParams);

    const flowState = useAppSelector((state) => state.registrationFlow);

    const {data: userInfo} = useGetUserProfileQuery();

    const {defaultValues: preferencesDefaultValues, maxBudget} = usePreferencesValues({
        creditPlan: userInfo?.financing_services ?? false,
        property: flowState.propertyId,
        offer: flowState.offerId
    });

    const regionIds = flowState.preferences?.regions || [];

    const {data} = useGetRegionDetailListQuery({regionIds}, {skip: !regionIds.length});

    if (!userInfo) {
        return null;
    }

    const listingLink = getSearchUrlWithFilters({
        singleRegionFriendlyLink: rpAppLink.offer.listFriendly,
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: {},
        searchFormValues: {
            rooms: flowState.preferences?.rooms || preferencesDefaultValues.rooms,
            search: {
                label: "",
                tabType: SearchTab.Regions,
                regions: data || []
            },
            price: {upper: flowState.preferences?.price || maxBudget},
            type: [],
            area: null,
            floor_choices: [],
            construction_end_date: null,
            distance: null,
            house_type: null,
            house_additional_areas: null,
            house_storeys: null,
            instalment: null
        },
        abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad
    }).url;

    const handlers = {
        onClose: () => {
            onClose?.();
        }
    };

    return (
        <Modal isOpen={isOpen} className={modalStyle} onModalClose={handlers.onClose} overlayVariant={overlayVariant}>
            <div data-testid={PREFERENCES_SURVEY_MODAL_TEST_IDS.SUMMARY_MODAL}>
                <Modal.CloseButton placement="right" variant="rounded" className={css({m: 2})} />
                <Modal.Content className={modalContentStyle}>
                    <BrandHandclapIcon size="13" wrapperSize="13" wrapperColor="var(--colors-primary)" className={iconStyle} />
                    <Text variant="headline_2" align="center">
                        Twoje preferencje zostały zaktualizowane.
                    </Text>
                    <Text variant="body_copy_1" align="center" mb={1}>
                        Na podstawie Twoich preferencji{" "}
                        <span className={css({fontWeight: 700})}>będziemy wysyłać Ci co jakiś czas nowe, dopasowane oferty</span>. Pełną listę rekomendacji
                        zobaczysz w{" "}
                        <a href={kmLink} className={css({textDecoration: "underline"})}>
                            Koncie Mieszkaniowym
                        </a>
                        .
                    </Text>
                    <Button
                        variant="filled_primary"
                        size="small"
                        className={buttonStyle}
                        href={listingLink}
                        target="_blank"
                        dataTestId={PREFERENCES_SURVEY_MODAL_TEST_IDS.SUMMARY_BUTTON}
                    >
                        {isMobile ? "ZOBACZ PASUJĄCE OFERTY" : "ZOBACZ OFERTY"}
                    </Button>
                </Modal.Content>
            </div>
        </Modal>
    );
};

const modalStyle = css({
    sm: {
        p: 2,
        borderRadius: 2,
        width: "544px",
        height: "800px"
    }
});

const modalContentStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 3
});

const iconStyle = css({
    alignSelf: "center"
});

const buttonStyle = css({
    width: "max-content",
    alignSelf: "center"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandHandclapIcon} from "@pg-design/icons-module";
import {type IModalOverlayVariant, Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {rpAppLink} from "@pg-mono/rp-routes";
import {PREFERENCES_SURVEY_MODAL_TEST_IDS} from "@pg-mono/test-ids/src/rp/common/test_id";
import {useUserDevice} from "@pg-mono/user-device";

import {useKMLink} from "../../../hooks/use_km_link";
import {useGetRegionDetailListQuery} from "../../../region/api/get_region_detail_list";
import {SearchTab} from "../../../search/types/SearchTab";
import {getSearchUrlWithFilters} from "../../../search/utils/get_search_url_with_filters";
import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../api/get_user_profile";
import {usePreferencesValues} from "../../hooks/preferences/use_preferences_values";

interface IProps {
    isOpen: boolean;
    onClose?: () => void;
    overlayVariant?: IModalOverlayVariant;
}

export const UserPreferencesUpdateDataModal = (props: IProps) => {
    const {isOpen, onClose, overlayVariant} = props;

    const {isMobile} = useUserDevice();

    const kmLink = useKMLink(kmAppLink.site.offers.myInquiriesWithParams);

    const flowState = useAppSelector((state) => state.registrationFlow);

    const {data: userInfo} = useGetUserProfileQuery();

    const {defaultValues: preferencesDefaultValues, maxBudget} = usePreferencesValues({
        creditPlan: userInfo?.financing_services ?? false,
        property: flowState.propertyId,
        offer: flowState.offerId
    });

    const regionIds = flowState.preferences?.regions || [];

    const {data} = useGetRegionDetailListQuery({regionIds}, {skip: !regionIds.length});

    if (!userInfo) {
        return null;
    }

    const listingLink = getSearchUrlWithFilters({
        singleRegionFriendlyLink: rpAppLink.offer.listFriendly,
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: {},
        searchFormValues: {
            rooms: flowState.preferences?.rooms || preferencesDefaultValues.rooms,
            search: {
                label: "",
                tabType: SearchTab.Regions,
                regions: data || []
            },
            price: {upper: flowState.preferences?.price || maxBudget},
            type: [],
            area: null,
            floor_choices: [],
            construction_end_date: null,
            distance: null,
            house_type: null,
            house_additional_areas: null,
            house_storeys: null,
            instalment: null
        },
        abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad
    }).url;

    const handlers = {
        onClose: () => {
            onClose?.();
        }
    };

    return (
        <Modal isOpen={isOpen} className={modalStyle} onModalClose={handlers.onClose} overlayVariant={overlayVariant}>
            <div data-testid={PREFERENCES_SURVEY_MODAL_TEST_IDS.SUMMARY_MODAL}>
                <Modal.CloseButton placement="right" variant="rounded" className={css({m: 2})} />
                <Modal.Content className={modalContentStyle}>
                    <BrandHandclapIcon size="13" wrapperSize="13" wrapperColor="var(--colors-primary)" className={iconStyle} />
                    <Text variant="headline_2" align="center">
                        Twoje preferencje zostały zaktualizowane.
                    </Text>
                    <Text variant="body_copy_1" align="center" mb={1}>
                        Na podstawie Twoich preferencji{" "}
                        <span className={css({fontWeight: 700})}>będziemy wysyłać Ci co jakiś czas nowe, dopasowane oferty</span>. Pełną listę rekomendacji
                        zobaczysz w{" "}
                        <a href={kmLink} className={css({textDecoration: "underline"})}>
                            Koncie Mieszkaniowym
                        </a>
                        .
                    </Text>
                    <Button
                        variant="filled_primary"
                        size="small"
                        className={buttonStyle}
                        href={listingLink}
                        target="_blank"
                        dataTestId={PREFERENCES_SURVEY_MODAL_TEST_IDS.SUMMARY_BUTTON}
                    >
                        {isMobile ? "ZOBACZ PASUJĄCE OFERTY" : "ZOBACZ OFERTY"}
                    </Button>
                </Modal.Content>
            </div>
        </Modal>
    );
};

const modalStyle = css({
    sm: {
        p: 2,
        borderRadius: 2,
        width: "544px",
        height: "800px"
    }
});

const modalContentStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 3
});

const iconStyle = css({
    alignSelf: "center"
});

const buttonStyle = css({
    width: "max-content",
    alignSelf: "center"
});
